/**
 * =============================================================
 * AADHAV ACADEMY – ADMIN FEE REPORTS SELECTORS
 * Role: Admin
 * Scope: Memoized state selectors for fee reports & financial metrics
 * Standard: Enterprise / MNC Level
 * =============================================================
 */

export const selectFeeReportsState = (state) =>
  state.admin?.feeReports || state.feeReports || {};

export const selectFeeReportFilterContext = (state) =>
  selectFeeReportsState(state).filterContext || {};

export const selectFinancialSummary = (state) =>
  selectFeeReportsState(state).financialSummary || {
    total_expected: 0.00,
    total_received: 0.00,
    total_pending: 0.00,
  };

export const selectDefaultersCount = (state) =>
  selectFeeReportsState(state).defaultersCount || 0;

export const selectDefaultersList = (state) =>
  selectFeeReportsState(state).defaultersList || [];

export const selectFeeReportsLoading = (state) =>
  selectFeeReportsState(state).loading || false;

export const selectFeeReportsError = (state) =>
  selectFeeReportsState(state).error || null;